export type FormBarButtons = 'previousButtonArea' | 'savedProfilesButtonArea' | 'saveAsProfileButtonArea' | 'nextButtonArea';

export const FORM_BAR_BUTTONS: { [key in FormBarButtons]: FormBarButtons } = {
  previousButtonArea: 'previousButtonArea',
  savedProfilesButtonArea: 'savedProfilesButtonArea',
  saveAsProfileButtonArea: 'saveAsProfileButtonArea',
  nextButtonArea: 'nextButtonArea',
};
